import CustomerOrderApi from "../api/customerOrderApi";
import UserApi from "../api/userApi";
import { IApiContext } from "../interfaces/IApiContext";
import { IDataContext } from "../interfaces/IDataContext";
import { IRootState } from "../interfaces/IRootState";

export const initialApiContext: IApiContext = {
  userApi: undefined,
  customerOrderApi: undefined,
};

export const initialDataContext: IDataContext = {
  state: null,
  setRootState: null,
  handleMessage: null,
};
export const GetInitialRootState = (): IRootState => ({
  navigationExpanded: false,
  isLoading: false,
  isFetchingMore: false,
  folderIsDownLoading: "",
  message: null,
  initialLoading: true,
  accessToken: null,
  authUser: undefined,
  customers: [],
  selectedCustomer: undefined,
  orders: [],
  nextPageToken: null,
  tickets: [],
  ticketsNextPageToken: null,
  isLoadingTickets: false,
  isLoadingMoreTickets: false,
});

export const GetApiContext = (): IApiContext => {
  const userApi = new UserApi();
  const customerOrderApi = new CustomerOrderApi();
  const ctx: IApiContext = {
    userApi,
    customerOrderApi,
  };
  return ctx;
};
